import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";

export type AdminTag = {
  id: string;
  name: string;
  name_translations?: Record<string, string>;
  color?: string;
  seeded?: boolean;
};

function extractTagsArray(responseBody: unknown): unknown[] {
  if (!responseBody || typeof responseBody !== "object") return [];
  const body = responseBody as Record<string, unknown>;

  if (Array.isArray(body)) return body;

  const payload = body.data;

  if (Array.isArray(payload)) return payload;

  if (payload && typeof payload === "object") {
    const inner = payload as Record<string, unknown>;
    if (Array.isArray(inner.tags)) return inner.tags;
    if (Array.isArray(inner.items)) return inner.items;
  }

  if (Array.isArray(body.tags)) return body.tags;

  return [];
}

function mapRawTag(tag: unknown): AdminTag | null {
  if (!tag || typeof tag !== "object") {
    if (typeof tag === "string" && tag) {
      return { id: tag, name: tag, seeded: true };
    }
    return null;
  }
  const raw = tag as Record<string, unknown>;
  const name = String(raw.name ?? raw.tag_name ?? raw.label ?? "");
  if (!name) return null;
  const nameTranslations = raw.name_translations;
  return {
    id: String(raw.id ?? raw.tag_id ?? name),
    name,
    name_translations:
      nameTranslations &&
      typeof nameTranslations === "object" &&
      !Array.isArray(nameTranslations)
        ? (nameTranslations as Record<string, string>)
        : undefined,
    color: raw.color ? String(raw.color) : undefined,
    seeded: raw.seeded !== false,
  };
}

export async function fetchAdminTags(): Promise<AdminTag[]> {
  const token = JSON.parse(localStorage.getItem("token") ?? "null");
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);

  const { data: responseBody } = await instance.get(API_ROUTES.GET_ADMIN_TAGS);
  if (
    responseBody &&
    typeof responseBody === "object" &&
    (responseBody as Record<string, unknown>).success === false
  ) {
    throw new Error(
      ((responseBody as Record<string, unknown>).message as string) ||
        "Failed to fetch tags",
    );
  }

  const rawTags = extractTagsArray(responseBody);
  return rawTags.map(mapRawTag).filter((t): t is AdminTag => t !== null);
}
